import { CourseContentSection } from "../../models/page-builder/course-content.model";
import { Course } from "../../models/course.model";

export const MOCK_COURSE_CONTENT_SECTION: CourseContentSection = {
  type: "course-content",
  content: {
    headings: {
      title: "Course Content",
      titleColor: "#333",
      subTitle: "Check out our top picks",
      subTitleColor: "#666",
    },
    course: {
      id: "iUCxLQPukYQSKMPzWwJH",
    } as Course,
  },
  design: {
    layout: {
      blockStyle: "card",
      headingAlignment: "left",
    },
    appearance: {
      cardBackgroundColor: "#fff",
      pageBackgroundColor: "#f5f5f5",
      sectionTitleColor: "#333",
      lessonTitleColor: "#666",
      contentInfoColor: "#999",
    },
  },
}
